import { STORAGE_TOKEN } from '../constants/storage'

export const getStorage = local => (local ? localStorage : sessionStorage)

export const clearLocalStorage = () => {
  localStorage.clear()
  console.warn('localStorage has been cleared')
}

const normalizeToken = token => {
  if (!token || token === 'null' || token === 'undefined') {
    return null
  }

  return token
}

export const getToken = () => {
  const localToken = normalizeToken(localStorage.getItem(STORAGE_TOKEN))
  const sessionToken = normalizeToken(sessionStorage.getItem(STORAGE_TOKEN))

  return localToken || sessionToken
}

export const setToken = (token, local = true) => {
  const normalizedToken = normalizeToken(token)

  if (!normalizedToken) {
    localStorage.removeItem(STORAGE_TOKEN)
    sessionStorage.removeItem(STORAGE_TOKEN)
    return
  }

  const storage = getStorage(local)
  storage.setItem(STORAGE_TOKEN, normalizedToken)
}

export const removeToken = () => {
  localStorage.removeItem(STORAGE_TOKEN)
  sessionStorage.removeItem(STORAGE_TOKEN)
}

export const removeUserInfo = () => {
  localStorage.removeItem('userInfo')
}